import { PRODUCT_TYPE, PRODUCT_TYPE_SLUG } from '@ahmdigital/constants';
import { toUpper } from 'lodash/fp';

import { ProductTypeType } from '../../../../types/product';
import ahmConstants from '../../../../ahm-constants';

const { URLS } = ahmConstants;

type RefinePriceProductType = Exclude<ProductTypeType, 'combined' | 'ambulance'>;
type RefinePriceProductSlug = Uppercase<RefinePriceProductType>;

const getDestinationUrl = (productType: Exclude<ProductTypeType, 'ambulance'>, isChooseYourExtras = false) => {
  const validatedType = productType === PRODUCT_TYPE.COMBINED ? PRODUCT_TYPE.PACKAGE : productType;

  if (validatedType === PRODUCT_TYPE.PACKAGE) {
    return URLS.SALES.CHOOSE_YOUR_COVER;
  }

  if (isChooseYourExtras && validatedType === PRODUCT_TYPE.EXTRAS) {
    return URLS.SALES.CHOOSE_YOUR_EXTRAS_COVER;
  }

  return `${URLS.SALES.PRODUCT_LISTING}/${PRODUCT_TYPE_SLUG[toUpper(validatedType) as RefinePriceProductSlug]}/all`;
};

export default getDestinationUrl;
